module.exports = __webpack_public_path__ + "static/media/refresh.b9faca1c.svg";